var MessageCh = {

  NavabarText: {
    navbar_home: "首页",
    navbar_about: "关于熵达",
    navbar_product:"产品中心",
    navbar_academic_trends: "学术动态",
    navbar_contact: "联系我们",
    navbar_item: "企业社会责任",
    navbar_item_story:'责任故事',
    support_part:'拥党爱党',
    navbr_new: '新闻资讯',
    navbr_join:'招贤纳士',
    navbr_child_about_1:'公司介绍',
    navbr_child_about_2:'资质荣誉',
    navbr_child_about_3:'企业文化',
    navbr_child_about_5:'文化标语',
    navbr_child_about_4:'发展之路',
    
    navbr_child_news_1:'公司资讯',
    navbr_child_news_2:'行业动态',
    
    navbr_child_case_1:'学术直播',
    navbr_child_case_2:'经典视频',
    navbr_child_case_3:'学术沙龙会',
    
    navbr_child_join_1:'人才理念',
    navbr_child_join_2:'人才招聘',
    navbr_child_join_3:'职业发展',
    product_introduct:'产品介绍',
    navbr_new_one:'新闻资讯',
    
    company_introduct:'公司简介',
    company_team:'公司团队',
    company_person:'人文关怀',
    company_env:'公司环境',
    team_culture:'团队文化',
    team_culture_desc:'八小时之内求生存，八小时之外求发展',
    company_culture_title:'企业理念：',
    company_culture_desc:'讲诚信、讲原则、讲效率、懂感恩。',
    company_news:'公司资讯',
    navbr_item_desc:'熵达在长期的社会责任管理与实践中，有意识地将承担历史使命、履行社会责任和推动企业可持续发展有机统一，逐步形成了具有自身特色的社会责任管理模式——使命引领型社会责任管理。该模式涵盖了责任文化、责任管理、责任践行等子模块，明确了熵达开展社会责任工作的目标、指导思想、履责领域、组织动力和工作路径，是熵达推进社会责任工作的总体思路和行动路线。',

    join_us:'加入我们',
    contact_us_desc:'熵达不忘初心，一直秉持着“为健康生活助力”的使命砥砺前行！',
    salon_one:'“卓粤南医”首届胃肠肿瘤精准微创外科大会（签到留影）',
    salon_two:'广州市医学会胃肠外科学分会学术年会暨广州胃肠微创外科高峰论坛',
    salon_three:'肝胆相照，共筑健康——广东省健康科普促进会肝胆胰健康管理分会（暨第一届柔济妊娠期肝胆胰疾病诊治学习班）成立大会',
    salon_four:'2024尿路修复学术论坛',
    salon_five:'2021.12.3珠江医妇科会议学习',
    salon_six:'2020.8.7單孔腹腔鏡在婦科的應用沙龍會（廣州站）',
    company_culture_desc_1:'八小时之内求生存，八小时之外求发展',
    company_culture_desc_2:'过度学习，过度训练自己',
    company_culture_desc_3:'业绩做不好，证明自己还不够努力',
    company_culture_desc_4:'讲诚信、讲原则、讲规矩、讲效率',
    company_culture_desc_5:'目标、想法、行动',
    company_culture_desc_6:'过去、现在、未来',
    company_culture_desc_7:'忠心人品大于能力',
    company_culture_desc_8:'用感恩充实你的思想，让行动实践你的感恩',
    company_culture_desc_9:'一次性把事情做好',
    company_culture_desc_10:'赢在责任心，胜在执行力',
  },
  About_Navbar: {
    Company: '公司简介',
    Horor: '荣誉与资质',
    Technology: '科研技术',
    Team: '我们的团队',
    introduct:'广州市熵达贸易有限公司创立于2014年，扎根广州，现已服务于全省各大三甲医院，陆续进驻全国及海外市场；是一家专注于大外科领域医疗耗材与医疗设备的专业销售及服务企业。公司自成立以来，始终聚焦外科临床需求，深耕手术室、普外科、胸外科、泌尿科、妇产科等大外科核心场景，构建起覆盖高品质医疗耗材、专科医疗设备的完整供应体系，为各级医疗机构提供合规、优质、稳定的产品与一站式采购解决方案。熵达积极搭建产研协同转化平台，紧密联结临床专家与科研机构，推动医学创新成果向临床产品的有效转化，助力提升外科医疗技术成果的应用水平。依托规范化运营、严格的质量管控与高效的供应链服务，熵达坚持以“讲诚信、讲原则、讲效率、懂感恩”为企业理念，与国内外多家优质医疗生产企业建立长期稳定合作，持续为临床一线提供安全可靠、性价比优异的外科产品。立足大湾区，服务大健康。未来，熵达将继续深耕大外科领域，不断优化产品结构与服务能力，助力提升医疗诊疗质量，成为医疗机构值得信赖的外科医疗耗材与设备合作伙伴。',
    team_desc:'公司以服务第一、诚信经营，合作共赢为宗旨；年轻而富有朝气的销售团队拥有本科及以上学历，具有医学、药学、企业管理等多学科专业人才； 致力于在医疗市场中以高效、专业、奋进、务实的团队勠力同心服务 一个客户，优秀的员工队伍为熵达的快速发展奠定了坚实的基础，力争成为行业中的佼佼者。',
    eve:'温馨的工作环境、和谐的工作氛围有利于促进人际关系的和谐，激发员工的上进心，提高工作效率，促进了企业的发展。',
    eve_person:'在[熵达]，我们以人文关怀为核心，打造温暖成长之家。我们给员工提供：带薪旅游、员工父母关怀、下午茶、季度团建、健康运动、生日福利、年假、年度体检、入职礼包、周年礼包、良好的培训机制、师徒带教机制...... ',
    eve_person_1:'通过四季更迭的团队活动、专属定制的星光日、诗意栖息的旅行体验以及孝心接力的亲情关怀，我们让每一位伙伴在欢笑与成长中感受归属。无论是户外拓展的默契协作，还是生日惊喜的独特时刻，亦或是山水间的滋养与探索，我们用心编织情感网络，将关怀延伸至员工的家人，让温暖双向流动。在这里，企业不仅是事业的平台，更是情感的港湾，我们以真心换真心，让每个奋斗的身影在温暖中坚定前行，共同创造更大价值。',
  },
  New_NavBar: {
    Notice: '公司通告',
    MediaCentre: '媒体中心',
  },
  indexText: {

    more: "更多",

  },
  footText: {
    companys: '广州市熵达贸易有限公司',
    address: "广州市白云区",
    addresss: '广州市白云区',
    phone: "电话",
    email: "邮箱",
    address_s: "地址",
    weixin: "扫码关注公众号",
    aboutUs: '关于我们',
    company: '公司',
    honor: '荣誉与资质',
    technology: '科研技术',
    team: '我们的团队',
    services: '服务项目',
    news: '最新消息',
    notice: '公司通告',
    mediaCentre: '媒体中心',
    contact: '联络我们',
    talentRecruitment: '人才招聘',
    OfficeHours: '营业时间',
    day1: '星期一至五',
    day2: '星期六至日',
    version: '版权所有 © 广州市熵达贸易有限公司 2021-2022',
    back: '返回首页',

  },
  HomeText: {
  
  },
  AboutUs: {
    h_c: '关于我们',
    jj_t_1: '公司简介',
    jj_t_2: '关于广州市熵达贸易有限公司',
    j_t_1:'广州市熵达贸易有限公司以下简称：熵达,熵达是一家助力中小企业数字化经营升级的企业，公司拥有丰富项目经验的项目经理、专业界面设计师、交互设计师以及程序工程师。优易科提出 "做客户易懂的网络" 的口号。优易科提出 "让网络更简单" 的口号。',
    j_t_2:'我们为客户提供专业的定制网络建设服务。服务项目涵盖了网页视觉设计、VI标志设计、网站程序开发、HTML5响应式网站建设、手机网站开发、微商城、小程序开发、网站托管及维护、WEB系统开发、域名注册、国内外服务器租用、视频、平面设计、SEO优化排名等。帮助企业更容易的获取用户流量，为企业提升产品和创造价值提供最坚实的支撑。'


  },
  concat: {
    h_t: '联络我们',
    form_t: '期望与您联系',
    ph_1: '给我们意见',
    name: '请输入您的名字',
    phone:'请输入您的电话',
    need:'请输入您的需求',
    codemsg:'请输入验证码',
    ph_3: '电话',
    ph_4: '邮箱',
    sub_t: '提交',
    location: '广州市白云区大源东宝街4号101铺',

  },
  ContractText:{
    termsofuse:'版权所有 © 广州市熵达贸易有限公司 2021',
  },

  VideoText:{
    video_one_abstract:'腹腔镜右半结肠癌根治术',
    video_one_date:'2021-06-22',
    video_one_desc:'腹腔镜右半结肠癌根治术适应于治疗横结肠左半、结肠肝曲、升结肠及阑尾等恶性肿瘤。腹腔镜手术因创伤小、恢复快等多种优势在结直肠癌手术中应用越来越普及，多个临床研究证实，CME理论指导下的右半结直肠癌根治术可以得到最大程度的淋巴结清扫范围，并且降低局部复发喝远处转移风险，延长总生存。',
    video_two_abstract:'腹腔镜胃癌根治术',
    video_two_date:'2018-02-11',
    video_two_desc:'腹腔镜胃癌根治术是借助腹腔镜技术对患者进行胃癌根治。在脐部做一个1厘米的孔，放置穿刺装置，然后注入二氧化碳气体，使腹部隆起，通过穿刺装置放入照相机，可以观察整个腹腔。左、右上腹部各设0.5×1.5cm孔，各2孔。将穿刺装置置入超声刀和钳子内操作，切断胃周围血管，清扫胃周围淋巴结，上腹部小口约10cm，切除胃及周围大网膜淋巴结，行消化道吻合术，腔镜微创手术创伤较小，手术后恢复也比较快，是目前常用的手术方法之一。',
  },

  productIntroduct:{
    product_desc:'熵达矢志投身于医疗行业的产品研发生产、医疗器械销售、医疗行业文化服务等领域，以丰富的产品、专业的技术服务、完善的售后服务于各大三甲医院、门诊及其他医疗机构，为其提供完善的医疗产品服务解决方案，产品类型涵盖手术室、妇产科、泌尿科 、儿科、肛肠科、乳腺科、胃肠科等外科系统。',
    product_one:'包皮枪',
    product_two:'一次性使用腔镜直线切割闭合器',
    product_three:'微创筋膜闭合器（微抓钳minilap）',
  },
  honor:{
    start:'初创业',
    item_1:'2014年:公司成立',
    item_2:'2015年：首次与医疗产品生产商签署合作',
    item_3:'2016年：与多家行业领先医疗产品公司达成合作',
    item_4:'2017年：业务范围扩大并覆盖服务于多家大三甲医院',
    item_5:'2018年：成为多个品牌产品的广东省总代理并与多产品平台建立合作',
    item_6:'2019年：开创专利研发项目，孵化自身产品品牌，服务面向全国市场',
    item_7:'2020年：搭建学术资源平台，优化战略发展架构。奠定集团化发展方向',
    item_8:'2021年： 获得2021年度“守合同重信用企业”荣誉称号，设备中标三家大三甲医院',
    end:'艰苦奋斗',
  },
  corporate:{
    item_1:'企业使命',
    item_1_desc:'为健康生活助力',
    item_2:'企业愿景',
    item_2_desc:'成为健康产业的引导者',
    item_3:'企业精神',
    item_3_desc:'以诚信赢得信赖，以细节决定成败',
    item_4:'企业口号',
    item_4_desc:'努力工作，健康生活，团结友爱，共创佳绩',
  },
  concept:{
    item_1:'秉持“为健康生活助力”初心使命，把熵达打造成一个海纳百川的组织，在这个组织里，普通的人变成优秀的人，优秀的人变成卓越的人，源源不断的人在这里实现自己的人生梦想。',
    item_2:'培养和造就一支赢得市场领先、创造组织优势、引领价值导向、有使命感与责任感的人才队伍，支持战略目标的实现，是熵达持续不断的人才追求。',
    item_3:'熵达从生活、情感、成长环节关爱员工。',
    item_4:'熵达人珍视自己内心的梦想和追求，因为有梦想才更加有活力、更加有创造力、更加有超越其他组织和个人的推动力，实现自我境界的升华。',
    item_5:'人才管理从战略和组织发展需求出发，围绕熵达人才队伍建设，针对不同人才群体形成差异化的管理系统，构成人才标准、规划、选拔、培养、使用和保留的管理闭环。',
    item_6:'熵达推动关键岗位员工进行多岗位、跨职能、跨行业历练，不断优化人与岗位、人与团队、人与组织的匹配度，完善人才队伍的结构和水平，保持组织的激情与活力。',
  },
  postData:{
    name:'姓名',
    name_placeholder:'请填写姓名',
    phone:'联系方式',
    phone_placeholder:'请填写联系方式',
    post:'应聘岗位',
    post_placeholder:'请选择应聘岗位',
    submit:'提交信息' ,
  }
};


export {

  MessageCh

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js